import { useEffect, useState } from "react";
import { fetchCompareRates, fetchExchangeRate } from "../services/remittance";

const useExchangeRate = ({ effective_exchange_rate }) => {
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(null);
  const [fxRateData, setFxRateData] = useState({});
  const [compareRateData, setCompareRateData] = useState([]);
  const [dataToRender, setDataToRender] = useState([]);

  const getCompareRates = async () => {
    const compareRateData = await fetchCompareRates();
    if (compareRateData?.success) {
      const partnersData = compareRateData.response;
      setCompareRateData(partnersData);
      setDataToRender(partnersData?.slice(0, 3));
      setLoader(false);
    }
  };

  const handleShowMore = () => {
    setDataToRender([
      ...dataToRender,
      ...compareRateData?.slice(3, compareRateData.length),
    ]);
  };

  const getExchangeRate = async () => {
    try {
      setLoader(true);
      if (!effective_exchange_rate) {
        const exchangeRate = await fetchExchangeRate();
        if (exchangeRate?.success) {
          setFxRateData({
            ...exchangeRate,
            promotional_exchange_rate_applicable: true,
          });
          await getCompareRates();
          setLoader(false);
        }
        return;
      }
      getCompareRates();
      setLoader(false);
    } catch (error) {
      console.log(error);
      const message = error?.response?.data?.error?.message || error.message;
      setLoader(false);
      setError(message);
    }
  };

  useEffect(() => {
    getExchangeRate();
  }, []);

  return {
    loader,
    error,
    fxRateData,
    compareRateData,
    dataToRender,
    handleShowMore,
  };
};
export default useExchangeRate;
